import React from "react";
import ReactDOM from "react-dom";
import AppHeader from "./header";
import Footer from "./footer";
import {
  App,
  Article,
  Split,
  Box,
  Sidebar,
  Header,
  Title,
  Menu,
  Anchor,
  Button,
  User,
  Section,
  Paragraph,
  Heading,
  Label
} from "grommet";
import ProjectList from "./projects/all";

class Projects extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = { selectedProject: 0, responsive: false };
    this.selectHandler = this.selectHandler.bind(this);
    this.onResponsive = this.onResponsive.bind(this);
  }

  selectHandler(n) {
    this.setState({ selectedProject: n });
  }

  onResponsive(x) {
    this.setState({ responsive: x === "single" });
  }

  render() {
    return (
      <div>
        <Split flex="right" onResponsive={this.onResponsive}>
          <ProjectsSidebar
            selectedProject={this.state.selectedProject}
            selectHandler={this.selectHandler}
          />
          <ProjectSections
            selectedProject={this.state.selectedProject}
            responsive={this.state.responsive}
            selectHandler={this.selectHandler}
          />
        </Split>
      </div>
    );
  }
}

const ProjectsSidebar = props => (
  <Sidebar colorIndex="grey-2-a" size="small">
    <Header pad="small" justify="between" />
    <Menu pad="small" size="small" style={{ whiteSpace: "pre-wrap" }}>
      {(() => {
        let sectionIndex = 0;
        return ProjectList.map(p => {
          const i = sectionIndex;
          if (p.component) {
            sectionIndex += 1;
            return (
              <Paragraph margin="small" size="small">
                <a onClick={() => props.selectHandler(i)}>{p.title}</a>
              </Paragraph>
            );
          } else {
            return (
              <Heading
                strong={true}
                tag="h4"
                margin="none"
                style={{ "margin-top": "25px" }}
              >
                {p.title}
              </Heading>
            );
          }
        });
      })()}
    </Menu>
  </Sidebar>
);

class ProjectSections extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <Article scrollStep={false} full={true}>
        <AppHeader page="projects" />
        {this.props.responsive ? (
          <Menu
            alignSelf="center"
            margin="large"
            label={
              ProjectList.filter(p => !!p.component)[this.props.selectedProject]
                .title
            }
          >
            {ProjectList.filter(p => !!p.component).map((p, i) => (
              <Anchor
                label={p.title}
                onClick={() => this.props.selectHandler(i)}
              />
            ))}
          </Menu>
        ) : null}
        {(() => {
          const project = ProjectList.filter(p => !!p.component)[
            this.props.selectedProject
          ];
          return (
            <project.component
              colorIndex="light-1"
              responsive={this.props.responsive}
            />
          );
        })()}
        <Box flex="grow" />
        <Footer />
      </Article>
    );
  }
}

export default Projects;



// WEBPACK FOOTER //
// ./src/components/projects.js